import React, { useState } from 'react';
import { useGame } from '../context/GameContext';
import './PlayerSetup.css';

export default function PlayerSetup() {
  const { setUsername } = useGame();
  const [input, setInput] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    const name = input.trim();
    if (!name) { setError('Please enter a username'); return; }
    if (name.length < 2) { setError('Username must be at least 2 characters'); return; }
    if (name.length > 20) { setError('Username must be 20 characters or less'); return; }
    setUsername(name);
  };

  return (
    <div className="setup-bg">
      <div className="setup-glow" />
      <div className="setup-card animate-in">
        <div className="setup-logo">&#9670;</div>
        <h1 className="setup-title">learn<span>-ngk</span></h1>
        <p className="setup-tagline">Gamified Computer Basics Learning</p>

        <div className="setup-features">
          <div className="setup-feature">
            <span className="feature-icon">&#9670;</span>
            <span>5 Topics to Master</span>
          </div>
          <div className="setup-feature">
            <span className="feature-icon">&#9670;</span>
            <span>XP, Levels & Achievements</span>
          </div>
          <div className="setup-feature">
            <span className="feature-icon">&#9670;</span>
            <span>Timed Quizzes & Streak Bonuses</span>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="setup-form">
          <label className="setup-label">Choose your username</label>
          <input
            className="setup-input"
            type="text"
            value={input}
            onChange={e => { setInput(e.target.value); setError(''); }}
            placeholder="e.g. TechWizard"
            maxLength={20}
            autoFocus
          />
          {error && <p className="setup-error">{error}</p>}
          <button type="submit" className="btn btn-primary btn-lg setup-submit">
            Start Learning
          </button>
        </form>
      </div>
    </div>
  );
}
